// import Vue from 'vue';
// import axios from 'axios';
import AppConfig from '../configs/app.config.json';

export default async ({ app, router, store }) => {
  /* here we want to start fetching the config from the server and 
  pass that to our application store */

  // will come from specific project config/backend database
  const config =
    typeof AppConfig === 'string' ? JSON.parse(AppConfig) : AppConfig;
  store.commit('app/setAppConfig', config);
  // push to store for use in other components and methods
};
